import { IConnectRoom } from '@epicuro-next/data/connect';
import { createAction, props } from '@ngrx/store';

export const loadTwilioToken = createAction('[Connect] Load Twilio token');

export const loadTwilioTokenSuccess = createAction(
  '[Connect] Load Twilio token success',
  props<{ token: string }>(),
);

export const loadTwilioTokenFailure = createAction(
  '[Connect] Load the Twilio token failure',
  props<{ error: string }>(),
);

export const loadRoom = createAction('[Connect] Load the Twilio room');

export const loadRoomSuccess = createAction(
  '[Connect] Load the Twilio room success',
  props<{ room: IConnectRoom }>(),
);

export const loadRoomFailure = createAction(
  '[Connect] Load the Twilio room failure',
  props<{ error: string }>(),
);

export const setRoomNameState = createAction(
  '[Connect] Stop listen an specific socket message',
  props<{ roomName: string }>(),
);
